// Recovered compiled webpack factory 90737. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "AmpStateContext", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
  let r = n(28140)._(n(12115)).default.createContext({});
}
